import React, { Component } from "react";
import { withStyles, styled } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Grid, TextField, Snackbar } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { Table, DatePicker, Button, Input, Select, Tabs, Tooltip  } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { CloseOutlined, DeleteOutlined } from '@ant-design/icons'
const { TabPane } = Tabs;
const { RangePicker } = DatePicker;
const { Option } = Select;

import {
  getDictList,
  getTrainSourceOrgList,
  getTrainList,
} from "../../actions/publish";

const styles = () => {
  return {
    root: {
      width: "100%",
    },
    search: {
      width: "100%",
      height: "61px",
      padding: "18px 24px",
      flexFlow: "column",
      background: "#fff",
    },
    line: {
      height: "25px",
      fontSize: "14px",
      color: "#000",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    title: {
      marginRight: "10px",
      fontSize: "18px",
      fontWeight: "bold",
      color: "#5F6876",
    },
    btn: {
      width: "70px",
      height: "40px",
      background: "#3276C3",
      borderRadius: "0 !important",
    },
    container: {
      paddingTop: '20px'
    },
    tabBox: {
      height: "40px",
      "& .ant-tabs-nav": {
        marginBottom: "0 !important",
      },
      "& .ant-tabs-content-holder": {
        height: "0 !important",
      },
      "& .ant-tabs-tab-btn": {
        fontSize: "16px !important",
        fontWeight: "bold",
      },
    },
    tabContainer: {
      flex: "1",
      width: "100%",
      height: "1px",
      padding: "12px",
      background: "#fff",
      overflow: "hidden",
      boxShadow: "0 0 30px 10px rgba(0, 0, 0, .05)",
    },
    dateFilter: {
      width: "236px",
      padding: "8px",
    },
    defaultFilter: {
      width: "196px",
      padding: "8px",
    },
    btnLine: {
      marginTop: "8px",
      display: "flex",
      justifyContent: "space-between",
    },
    select: {
      width: "100%",
    },
    tableContainer: {
      width: "100%",
      "& .ant-table-cell-row-hover": {
        background: "#f0fbff !important",
      },
      "& td.ant-table-column-sort": {
        background: "#f0fbff !important",
      },
      "& .ant-table-cell": {
        wordBreak: "break-all !important",
      },
    },
    bold: {
      fontWeight: "bold",
    },
  };
};

class Train extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    loading: true,
    filteredInfo: null,
    filterForm: {},
    filterDropdownVisible: false,
    columns: [],
    data: [],
    tabIndex: 0,
    updateTime: '',
    searchHistoryList: [],
    form: {},
    defaultForm: { // 默认值
      TrainingMeetingType: "",
      KeyWord: "",
    },
    labelObj: { // 筛选项key - label对应关系
      KeyWord: '关键词',
      TrainingMeetingType: '类型',
    },
    labelListObj: { 
    },
    selectKeys: [],
    dataType: [],
    defaultOrder: "descend",
    isPayList: [
      {
        ID: "是",
        Name: "是",
      },
      {
        ID: "否",
        Name: "否",
      },
    ],
    page: {
      PageNo: 1,
      PageSize: 10,
    },
    total: 0,
    scrollObj: {
      x: 1600,
      y: 600,
    },
    sortObj: {
      SortCriteria: "TrainingTimeKS",
      SortCriteriaMode: "Desc",
    },
    paginationObj: {
      showSizeChanger: true,
      allTotal: 0,
      total: 0,
      showTotal: (total, range) => {
        return (
          "当前已筛选出【" +
          this.state.paginationObj.total +
          "】条，总数据量【" +
          this.state.paginationObj.allTotal +
          "】条"
        );
      },
      onChange: (page, pageSize) => {
        this.pageChange(page, pageSize);
      },
    },
  };

  getTableHeight = () => {
    // 计算表格高度
    let height = window.innerHeight
    let lineHeight = document.getElementById('searchBar').offsetHeight
    this.setState({
      scrollObj: {
        x: 1600,
        y: height - lineHeight - 211
      }
    })
  }


  componentDidMount() {
    this.getTableHeight()
    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let today = `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`
    this.setState({
      updateTime: today
    })
    
    let search = decodeURI(this.props.location.search)
    let params = search.substring(1).split('&')
    let obj = params.find(v => {
      return v.indexOf('keyword=') == 0
    })
    if (obj) {
      let urlKeyword = obj.split('=')[1]
      this.setState({
        form: {
          ...this.state.form,
          KeyWord: urlKeyword,
        },
        showKeys: ['KeyWord']
      }, () => this.initData())
    } else {
      this.initData()
    }
  }

  resetForm = () => {
    this.setState({
      form: {
        TrainingMeetingType: "",
        KeyWord: ""
      }
    })
  }

  clearHistory = () => {
    this.resetForm()
    this.setState({
      searchHistoryList: []
    }, () => this.initData())
  }

  removeSearchItem = (data, i) => {
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    form[data.key] = this.state.defaultForm[data.key]
    list.splice(i, 1)
    this.setState({
      form: form,
      searchHistoryList: list
    }, () => this.initData())
  }

  searchForm = () => {
    this.initData()
    // 添加历史搜索记录
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    for (let key in form) {
      let index = list.findIndex(v => {
        return v.key == key
      })
      if (form[key] && form[key].length > 0) {
        let showValue = form[key]
        let label = ''
        if (key == 'TrainingTime') {
          showValue = `${showValue[0].format("YYYY-MM-DD")} - ${showValue[1].format("YYYY-MM-DD")}`
        }
        if (this.state.selectKeys.indexOf(key) > -1) {
          label = this.state[this.state.labelListObj[key]].find(v => {
            return v.ID == showValue
          }).Name
        }
        if (index === -1) {
          let param = {
            label: this.state.labelObj[key],
            value: label || showValue,
            key: key
          } 
          list.push(param)
        } else {
          let itemIndex = list.findIndex(v => {
            return v.key == key
          })
          list[itemIndex].value = label || showValue
        }
      } else {
        if (index > -1) {
          list.splice(index, 1)
        }
      }
    }
    this.setState({
      searchHistoryList: list
    })
  }

  onChangeForm = (value, key) => {
    let form = {
      ...this.state.form
    }
    form[key] = value
    this.setState({
      form: form
    })
  }

 

  initData = () => {
    let TrainingTime = this.state.form.TrainingTime
    let param = Object.assign(
      {},
      this.state.form,
      this.state.page,
    );
    if (TrainingTime && TrainingTime.length > 0) {
      param.TrainingTimeKS = TrainingTime[0].format("YYYY-MM-DD")
      param.TrainingTimeJS = TrainingTime[1].format("YYYY-MM-DD")
    }
    delete(param.TrainingTime)
    getTrainList(param).then((res) => {
      if (!res.Error) {
        let newPaginationObj = this.state.paginationObj;
        newPaginationObj.total = res.DataNumber;
        newPaginationObj.allTotal = res.UnfilteredAllDataNumber;
        this.setState(
          {
            data: res.DataList,
            paginationObj: newPaginationObj,
            loading: false,
          },
          () => {
            this.getColumns();
          }
        );
      } else {
        this.setState({
          loading: false,
          data: [],
        });
      }
    });
  };

  getColumns = () => {
    let classes = this.props.classes;

    let columns = [
      {
        title: "类型",
        dataIndex: "TrainingMeetingType",
        width: 160,
        key: "TrainingMeetingType",
        render: (_, record) => {
          return (
            <div >{record.TrainingMeetingType}</div>
          );
        },
      },
      {
        title: "内容",
        dataIndex: "TrainingContent",
        key: "TrainingContent",
        width: 500,
        ellipsis: {
          showTitle: false,
        },
        render: (_, record) => {
          let content = record.TrainingContent.split("^").join('')
          return   <Tooltip placement="topLeft" title={content}>
            <span>{content}</span>
          </Tooltip>
        },
      },
      {
        title: "开始时间",
        dataIndex: "TrainingTimeKS",
        key: "TrainingTimeKS",
        width: 160,
        sortOrder: this.state.defaultOrder,
        render: (_, record) => {
          let str = record.TrainingTimeKS || ''
          return `${str.substring(0,10)}`
        },
      },
      {
        title: "链接地址",
        dataIndex: "WebUrl",
        width: 350,
        key: "WebUrl",
        render: (WebUrl) => (
          <a href={WebUrl} target="_blank">
            {WebUrl}
          </a>
        ),
      },
    ];

    this.setState({
      columns: columns,
    });
  };

  handleChange = (pagination, filters, sorter) => {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.getColumns();
        this.initData();
      }
    );
  };

  handleSort = () => {};

  clearFilters = () => {
    this.setState({ filteredInfo: null });
  };

  clearAll = () => {
    this.setState(
      {
        filteredInfo: null,
        page: {
          PageNo: 1,
          PageSize: 10,
        },
        form: {},
        loading: true,
      },
      () => {
        this.getColumns();
        this.initData();
      }
    );
  };

  handleReset = (clearFilters) => {
    clearFilters();
  };



  pageChange = (page, pageSize) => {
    if (
      page == this.state.page.PageNo &&
      pageSize == this.state.page.PageSize
    ) {
      return;
    }
    this.setState(
      {
        page: {
          PageNo: page,
          PageSize: pageSize,
        },
        loading: true,
      },
      () => this.initData()
    );
  };

  render() {
    const classes = this.props.classes;

    return (
      <div className="common-page">
        <div className="common-left-search">
          <div className="left-search-title">
            <span className="search-title">关键词搜索</span>
            
          </div>
          <div className="search-form">
            <div className="form-item">
              <div className="form-label">关键词</div>
              <Input  value={this.state.form.KeyWord}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'KeyWord')} 
                placeholder="请输入关键词"/>
            </div>
            <div className="form-item">
              <div className="form-label">类型</div>
              <Input  value={this.state.form.TrainingMeetingType}
                onChange={(e) => this.onChangeForm(e.target.value, 'TrainingMeetingType')} 
                placeholder="请输入类型"/>
            </div>
          </div>

          <div className="search-bottom-btns">
            <Button className="default-btn" onClick={this.resetForm}>重置</Button>
            <Button className="primary-btn" onClick={this.searchForm}>搜索</Button>
          </div>
        </div>

        <div className="common-main">
          <div className="common-main-search" id="searchBar">
            <div className="main-title">
              <div className="title-top">
                <div>
                  <span className="page-title">培训信息汇总</span>
                  <span className="page-count">{this.state.paginationObj.total}条</span>
                </div>
                <span >数据更新至：{this.state.updateTime}</span>
              </div>
            </div>
            {
              this.state.searchHistoryList.length > 0 &&
              <div className="search-history">
                {
                  this.state.searchHistoryList.map((item, i) => (
                    <div className="history-item" key={i}>
                      <span>{item.label}：</span>
                      <span className="history-value">{item.value}</span>
                      <CloseOutlined className="clear-icon" onClick={() => this.removeSearchItem(item, i)}/>
                    </div>
                  ))
                }
                <div className="hitstory-btn" onClick={this.clearHistory}>
                  <DeleteOutlined className="btn-icon"/>
                  清空
                </div>
              </div>
            }
          </div>
          <div className="common-main-container">
            <Grid container className={classes.container} id="tableContainer">
              <Table
                className={classes.tableContainer}
                columns={this.state.columns}
                loading={this.state.loading}
                dataSource={this.state.data}
                onChange={this.handleChange}
                pagination={this.state.paginationObj}
                bordered
              />
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(Train));
